export default __webpack_public_path__ + "static/media/34.a595632f.png";